module.exports = __webpack_public_path__ + "static/sergiler2-df6bed7f85410fb89bccbbab2fd0a468.png";